import type { ReactNode } from "react";
import { BrandMark, Notice } from "@/components/crm/blocks";
import { Card, CardContent } from "@/components/ui/card";

/** Losse pagina buiten de app (aanmelden, wachtwoord instellen): kaart in het midden met het logo. */
export function AuthLayout({ subtitle, message, children }: { subtitle: string; message?: { text: string; tone?: "yellow" | "blush" } | null; children: ReactNode }) {
  return (
    <main className="grid min-h-full place-items-center bg-surface-soft px-4 py-6">
      <Card className="w-full max-w-[400px]">
        <CardContent className="grid gap-1 p-5">
          <div className="mb-3.5 flex items-center gap-2.5">
            <BrandMark className="size-[38px] text-navy-800" />
            <div>
              <div className="font-brand text-[17px] font-semibold leading-[1.1] tracking-[.08em] text-navy-900">FURNIFLATS</div>
              <div className="text-xs text-muted-foreground">{subtitle}</div>
            </div>
          </div>
          {message && (
            <Notice tone={message.tone ?? "yellow"} className="mb-2.5">
              {message.text}
            </Notice>
          )}
          {children}
        </CardContent>
      </Card>
    </main>
  );
}

/** Label + invoerveld onder elkaar. */
export function Field({ label, htmlFor, children }: { label: string; htmlFor: string; children: ReactNode }) {
  return (
    <div className="mb-3 grid gap-1.5">
      <label htmlFor={htmlFor} className="text-[11px] font-bold uppercase tracking-[.06em] text-navy-700">
        {label}
      </label>
      {children}
    </div>
  );
}
